import styled, { css } from "styled-components";

export const Container = styled.div``;

export const Content = styled.div`
  display: flex;
  align-items: center;
`;

export const Input = styled.input`
  ${({ theme }) => css`
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    appearance: none;
    width: 1.3rem;
    height: 1.3rem;
    border: 0.2rem solid ${theme.colors.primary};
    border-radius: 0.2rem;
    transition: background border 0.1s ease-in-out;
    position: relative;
    outline: none;

    &:before {
      content: "";
      width: 0.5rem;
      height: 0.7rem;
      border: 0.2rem solid ${theme.colors.white};
      border-top: 0;
      border-left: 0;
      transform: rotate(45deg);
      position: absolute;
      top: 0;
      opacity: 0;
      transition: 0.1s ease-in-out;
    }

    &:focus {
      box-shadow: 0 0 0.5rem ${theme.colors.primary};
    }

    &:hover {
      border-color: ${theme.colors.gray};
      transition: 0.1s ease-in-out;
    }

    &:checked {
      border-color: ${theme.colors.primary};
      background: ${theme.colors.primary};

      &:before {
        opacity: 1;
      }
    }
  `}
`;

export const Label = styled.label`
  ${({ theme }) => css`
    cursor: pointer;
    padding-left: 0.5rem;
    color: ${theme.colors.primary};
    line-height: 1.8rem;
  `}
`;

export const ExtraInformation = styled.p`
  margin-top: 0.5rem;
  color: ${({ theme }) => theme.colors.gray};
  font-size: 0.75rem;
  padding-left: 2rem;

  @media (min-width: 640px) {
    font-size: 0.875rem;
  }
`;
